class StateListaObjetosConId {
  /**
   * @param {import('./listaObjetosConId').default} lista
   *
   */
  constructor(listaCompleta) {
    this._orden = null;
    this._filtros = null;
    this._listaCompleta = listaCompleta;
    this._ordenadas = listaCompleta;
    this._filtradas = listaCompleta;
  }

  get listaCompleta() {
    return this._listaCompleta;
  }

  get orden() {
    return this._orden;
  }

  get filtros() {
    return this._filtros;
  }

  get ordenadas() {
    return this._ordenadas;
  }

  get filtradas() {
    return this._filtradas;
  }

  equals(state) {
    return (
      this._orden.equals(state.orden) && this._filtros.equals(state.filtro)
    );
  }

  /**
   *
   * @param {import('./ordenListaObjetosConId').default} orden
   */
  setOrden(orden) {
    if (orden === null && this._orden !== null) {
      this._ordenadas = this._listaCompleta;
    } else if (
      (this._orden === null && orden !== null) ||
      !this._orden.equals(orden)
    ) {
      this._orden = orden;
      this._ordenadas = this._listaCompleta.sort(orden);
    }
    return this;
  }

  /**
   * Setea el filtro para la lista
   *
   * @param {import('./filtrosListaObjetosConId').default} filtros
   */
  setFiltros(filtros) {
    if (filtros === null && this._filtros !== null) {
      this._filtradas = this._listaCompleta;
    } else if (
      (this._filtros === null && filtros !== null) ||
      !this._filtros.equals(filtros)
    ) {
      this._filtradas = this._listaCompleta.filtrar(filtros);
    }

    return this;
  }

  /**

   * @returns Retorna la lista ordenada y filtrada segun los parametros definidos actualmente
   */
  getOrdenadasFiltradas() {
    return this._ordenadas.intersect(this._filtradas);
  }
}

export { StateListaObjetosConId as default };
